module.exports = __webpack_public_path__ + "resources/edit-35ebcb35eb4ad776b141255577123d01.svg";